var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.963,
    cy: 9.988,
    r: 9.25,
    fill: "#0500FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F7",
    strokeWidth: 2.167,
    d: "m5.357 9.785 3.147 3.147 5.885-5.885"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSign);
export default __webpack_public_path__ + "static/media/right-sign.1477129d880102cd7ba9f88dd84e5a97.svg";
export { ForwardRef as ReactComponent };